import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardWithForcedLogin {
  private _authService = inject(AuthService);
  private _router = inject(Router);

  public canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this._authService.isDoneLoading$
      .pipe(filter((isDone) => isDone))
      .pipe(tap(() => this._authService.isAuthenticated || this._authService.login(state.url)))
      .pipe(map(() => this._authService.isAuthenticated));
  }
}
